import { useState } from "react";
import { cn } from "@/lib/utils";

const MAX_AMOUNT = 999999;

// Compact £ input used across the wizard.
export const MoneyInput = ({ value, onChange, suffix, placeholder = "0", testId, className, required, error }) => {
  const [touched, setTouched] = useState(false);

  const handleChange = (e) => {
    const raw = e.target.value;
    // Strip anything that isn't a digit or single decimal point, max 2 decimal places
    const cleaned = raw.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1").replace(/(\.[0-9]{2}).*/, "$1");
    const num = parseFloat(cleaned);
    if (cleaned !== "" && (num < 0 || num > MAX_AMOUNT)) return;
    onChange(cleaned);
  };

  const handleBlur = () => setTouched(true);

  const showError = touched && ((required && !value) || error);
  const errorMsg = error || (required && !value ? "This field is required" : "");

  return (
    <div className={cn("relative flex flex-col", className)}>
      <div className="relative flex items-center">
        <span className="pointer-events-none absolute left-3 text-[#747D89] font-medium">£</span>
        <input
          type="text"
          inputMode="decimal"
          value={value}
          placeholder={placeholder}
          data-testid={testId}
          onChange={handleChange}
          onBlur={handleBlur}
          className={cn(
            "no-spinner w-full rounded-xl border bg-white py-2.5 pl-7 pr-3 text-[#1A1A1A] font-medium outline-none transition-colors duration-150 placeholder:text-[#8E99A8] focus:ring-2",
            showError
              ? "border-red-400 focus:border-red-400 focus:ring-red-100"
              : "border-[#E8EAEF] focus:border-[#734FFC] focus:ring-[#734FFC]/15"
          )}
        />
        {suffix && <span className="ml-2 shrink-0 text-sm text-[#747D89]">{suffix}</span>}
      </div>
      {showError && <p className="mt-1 text-right text-xs text-red-500">{errorMsg}</p>}
    </div>
  );
};

export const FieldRow = ({ label, hint, period, children, required }) => (
  <div className="flex items-center justify-between gap-4 py-1.5">
    <div className="min-w-0">
      <p className="text-sm font-medium text-[#1A1A1A] truncate">{label}{required && <span className="ml-0.5 text-red-500">*</span>}</p>
      {hint && <p className="text-xs text-[#747D89]">{hint}</p>}
    </div>
    <div className="w-32 shrink-0 sm:w-40">
      {children}
      {period && (
        <p className="mt-1 text-right text-[10px] font-semibold uppercase tracking-wide text-[#8E99A8]">{period}</p>
      )}
    </div>
  </div>
);
